import ClienteListStore from './ClienteListStore';
import ClienteInfoStore from './ClienteInfoStore.js';
import ClienteUpsertStore from './ClienteUpsertStore.js';
import ClienteBillingInfoStore from './ClienteBillingInfoStore.js';
import ClienteHitsAssignmentStore from './ClienteHitsAssignmentStore';

const ClienteStore = {
  list: ClienteListStore,
  info: ClienteInfoStore,
  upsert: ClienteUpsertStore,
  billing: ClienteBillingInfoStore,
  hits: ClienteHitsAssignmentStore,
};

export default ClienteStore;
